export const SlotType = {
  Number: "Number",
  Boolean: "Boolean",
  String: "String",
  Object3D: "Object3D",
  Slider: "Slider",
  Color: "Color",
  Dropdown: "Dropdown",
  Button: "Button",
};

export const SlotValidOption = [
  "target",
  "type",
  "label",
  "value",
  "tag",
  "enabled",
  "weak",
  "min",
  "max",
  "step",
  "pattern",
  "items",
  "multiselect"
];

const convertToSeparatedWords = (str) => {
  return str
    .replace(/^_/, "") // Remove leading underscore
    .replace(/([a-z])([A-Z])/g, "$1 $2") // Convert camelCase to space-separated
    .replace(/[-_]/g, " ") // Convert kebab-case and snake_case to spaces
    .replace(/\s+/g, " ") // Remove extra spaces
    .trim() // Trim spaces at start and end
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
};
/**
 *  SlotContext
 */
export class SlotContext {
  /**
   *
   */
  static _defaultByType(slotType) {
    let value = null;
    switch (slotType) {
      case SlotType.Number:
      case SlotType.Slider:
      case SlotType.Dropdown:
        value = 0;
        break;
      case SlotType.Boolean:
        value = false;
        break;
      case SlotType.Color:
        value = 0xFFFFFF;
        break;
      case SlotType.String:
      case SlotType.Object3D:
        value = null;
        break;
      case SlotType.Button:
        value = "Button"
        break;
      default:
        value = null;
    }
    return value;
  }

  /**
   *
   */
  static _hashKey(str) {
    let hash = 5381;
    for (let i = 0; i < str.length; i++) {
      hash = (hash << 5) + hash + str.charCodeAt(i);
    }
    return `id_${hash >>> 0}`;
  }

  /**
   *
   */
  static _createWeakProxy(target) {
    /*const weakRef = new WeakRef(target);
        return new Proxy({}, {
            get(_, prop) {
                const obj = weakRef.deref();
                return obj ? obj[prop] : null;
            },
            set(_, prop, value) {
                const obj = weakRef.deref();
                if (obj) {
                    obj[prop] = value;
                    return true;
                } else {
                    return false;
                }
            },
            has(_, prop) {
                const obj = weakRef.deref();
                return obj ? prop in obj : false;
            },
            deleteProperty(_, prop) {
                const obj = weakRef.deref();
                if (obj) {
                    return delete obj[prop];
                } else {
                    return false;
                }
            }
        });*/
    return {};
  }

  /**
   *
   */
  static apply(node) {
    node.slotRegistry?.clear();

    if (node.connectedSlots) {
      node.slotRegistry = node.connectedSlots;
    }

    node.getSlotByTag = (tag) => {
      let targetSlot = null;
      for (const it of node.slotRegistry.values()) {
        if (it.tag == tag) {
          targetSlot = it;
          break;
        }
      }
      return targetSlot;
    };

    delete node.connectedSlots;
  }

  /**
   * @param {*} node
   * @param {*} scene
   */
  static connectSlot(node, scene) {
    return (options) => {
      node.connectedSlots = node.connectedSlots || new Map();
      let connectedSlots = node.connectedSlots;
      let slots = node.slotRegistry || new Map();

      let {
        target,
        // String, Number, Boolean, Object3D, Color, Slider, Dropdown
        type,
        label,
        value = null,
        tag = null,
        enabled = true,
        // Object3D
        weak = false,
        // Number, Slider
        min = 0,
        max = 100,
        step = 1,
        // String
        pattern = null,
        // Dropdown
        items = [],
        multiselect = false,
      } = options;

      label = label || target;
      label = convertToSeparatedWords(label);

      // const key = SlotContext._hashKey(`${target}:${label}:${tag}:${type}:${enabled}:${min}:${max}:${step}:${pattern}:${items}:${multiselect}`);
      const key = SlotContext._hashKey(`${target}:${type}`);
      const DEFAULT_SLOT = {
        target,
        type,
        label,
        value: value || SlotContext._defaultByType(type),
        enabled,
        tag,
      };

      if (!slots.has(key)) {
        slots.set(key, DEFAULT_SLOT);
      }

      let currentSlot = slots.get(key);

      let ref = null;
      switch (currentSlot.type) {
        case SlotType.Object3D:
          ref = scene.getObjectByName(currentSlot.value);
          if (ref && weak) {
            ref = SlotContext._createWeakProxy(ref);
          }
          Object.assign(currentSlot, { label, enabled, tag, weak });
          break;
        case SlotType.Slider:
        case SlotType.Number:
          Object.assign(currentSlot, { label, enabled, tag, min, max, step });
          ref = currentSlot.value;
          break;
        case SlotType.String:
          Object.assign(currentSlot, { label, enabled, tag, pattern });
          ref = currentSlot.value;
          break;
        case SlotType.Dropdown:
          Object.assign(currentSlot, { label, enabled, tag, items, multiselect });
          ref = currentSlot.value;
          break;
        default:
          Object.assign(currentSlot, { label, enabled, tag });
          ref = currentSlot.value;
      }

      connectedSlots.set(key, currentSlot);
      return ref;
    };
  }
}
